import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, Button } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

export default function GearCode(props) {
  const [gearPref, setGearPref] = useState([]);
  const [gearOptions, setGearOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});

  useEffect(() => {
    const gears = props.gearCodeOptions;
    let filteredOptions = [];
    let quickPick = [];

    if (props.reportType === "3" && gears) {
      filteredOptions = gears.filter((gear) =>
        ["DRC", "RAK"].includes(gear.CODE)
      );
    } else {
      filteredOptions = gears.filter(
        (gear) =>
          gear.REPORT_TYPE.includes(Number(props.reportType)) &&
          gear.CODE !== "PTL"
      );
    }
    // * Created unique array to avoid duplicate buttons with same value
    const uniqueGearPreference = [
      ...props.gear_preference
        .reduce(
          (gear_preference, obj) => gear_preference.set(obj.gearcode, obj),
          new Map()
        )
        .values(),
    ];
    // * filtering quick picks by report_type
    quickPick = uniqueGearPreference.filter((el) => {
      return filteredOptions.some((opt) => opt.CODE === el.gearcode);
    });

    setSelectedValue({ NAME: props.gearname, CODE: props.gearcode });
    setGearPref([...quickPick]);
    setGearOptions([...filteredOptions]);
  }, [
    props.gearCodeOptions,
    props.gear_preference,
    props.gearcode,
    props.gearname,
    props.reportType,
  ]);

  return (
    <Box mt={0} width="100%" align="center" key={"gear_code_box"}>
      <h2 className="sectionTitle center">Gear Code</h2>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        key={"gear_code_grid"}
      >
        <Grid item xs={12} md="auto" key={"gear_code_grid_item"}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"gear_code_button_outer_box"}
          >
            {gearPref.map((gear_code, idx) => (
              <Box m={0.5} key={"gear_code_button_box_" + idx}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-gear-code={gear_code.gearcode}
                  size="large"
                  onClick={(e) =>
                    props.handleGearCodePreferenceChange(e, gear_code.gearcode)
                  }
                  key={gear_code.gearcode}
                  id={gear_code.gearcode}
                >
                  {gear_code.gearcode}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item key={"gear_code_item_auto"}>
          <Autocomplete
            id="gear_code_auto_complete"
            key={"gear_code_auto_complete"}
            options={gearOptions}
            getOptionLabel={(option) =>
              option.CODE ? option.CODE + " - " + option.NAME : ""
            }
            sx={{ maxWidth: 350, minWidth: 250, textAlign: "center" }}
            onChange={props.changeHandler}
            value={selectedValue}
            isOptionEqualToValue={(option) => option.NAME}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Gear Code"
                variant="standard"
                helperText={"Select Gear Code"}
              />
            )}
          />
        </Grid>
        <Grid item>
          <HelpText helpText={getHelpText(props.helpText, "gear_code")} />
        </Grid>
      </Grid>
    </Box>
  );
}
